import React, { useEffect, useState } from "react";
import { styled, Dialog } from "@mui/material";
import TextView from "../../../TextView";
import { useStore } from "react-redux";
import { getAllCards } from "../../../../services/api";
import { cardIcon } from "../../../Settings/Billing/helper";
import CreditCardIcon from "assets/images/tokens/creditCard.svg";
import Button from "../../../Button";
import AddPayment from "../../../Settings/AddPayment";

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

const ConfirmationTextContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingRight: "32px",
  paddingLeft: "32px",
}));

const TokenDetailsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const CardDetailsContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  height: "86px",
  gap: "16px",
  paddingRight: "24px",
  paddingLeft: "24px",
  borderTop: "1px solid #e0e0e0",
  borderBottom: "1px solid #e0e0e0",
}));

export const CardDetails = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const ConfirmPurchase = () => {
  const store = useStore();
  const state = store.getState();
  const bundle = state.aiWheels.selectedBundle;

  const [cardToShow, setCardToShow] = useState(null);
  const [openAddModal, setOpenAddModal] = useState(false);

  const fetchAllCards = async () => {
    const response = await getAllCards();
    const card = response?.data?.cards?.find(
      (card) => card.is_default || response?.data?.cards?.[0]
    );
    if (card) {
      setCardToShow(card);
    }
  };

  useEffect(() => {
    fetchAllCards();
  }, []);

  const handleModalClose = () => {
    setOpenAddModal(false);
    fetchAllCards();
  };

  return (
    <Container>
      <ConfirmationTextContainer>
        <TextView variant="subtitle" style={{ fontWeight: 700 }}>
          You are about to purchase
        </TextView>
        <TokenDetailsContainer>
          <TextView variant="subtitle" style={{ color: "#565556" }}>
            {bundle?.token_amount} AI Tokens
          </TextView>
          <TextView variant="subtitle" style={{ color: "#565556" }}>
            for ${bundle.is_discounted ? bundle.discounted_price : bundle.price}
          </TextView>
        </TokenDetailsContainer>
      </ConfirmationTextContainer>

      {cardToShow ? (
        <CardDetailsContainer>
          <img
            src={cardIcon[cardToShow?.brand]}
            alt="visa"
            width={44}
            height={30}
          />
          <CardDetails>
            <TextView variant="subtitle" style={{ fontWeight: 700 }}>
              Mastercard ending with {cardToShow?.last4}
            </TextView>
            <TextView variant="largeText">
              Exp. date {cardToShow.expiry_month}/{cardToShow.expiry_year}
            </TextView>
          </CardDetails>
        </CardDetailsContainer>
      ) : (
        <CardDetailsContainer>
          {/* <CardDetails>
                    <TextView variant="subtitle" style={{ fontWeight: 700 }}>
                        Add Payment Method
                    </TextView>
                    <TextView variant="largeText">
                        Securely save a payment method to make transactions faster and easier.
                    </TextView>
                </CardDetails> */}
          <Button variant="outlined" onClick={() => setOpenAddModal(true)}>
            Add Payment Method
          </Button>
        </CardDetailsContainer>
      )}

      <Dialog
        open={openAddModal}
        onClose={handleModalClose}
        fullWidth
        maxWidth="sm"
      >
        <AddPayment closeModal={handleModalClose} />
      </Dialog>
    </Container>
  );
};
